import { AttributeName } from "../attribute/attribute";
import { Resource } from "../resource";

export class Filter extends Resource {
    count: number;
    name:  AttributeName;
    value: string;
}
